import api from 'ApiConfig';

const placementService = {
  createPlacementOfficer: async (accountantData) => {
    return api.post('/admin/create-placement-officer', accountantData);
  },
  getAllPlacementOfficer: async (userId, selectedBranch) => {
    return api.post('/admin/get-all-placement', { userId, selectedBranch });
  },
  updatePlacementOfficer: async (payload) => {
    const {
      name: placementName,
      email: placementEmail,
      password: placementPassword,
      _id: placementId,
      hrRole,
      allPermission,
      branches,
    } = payload;
    const updatedPayload = {
      placementName,
      placementEmail,
      placementPassword,
      placementId,
      hrRole,
      allPermission,
      branches,
    };
    return api.post('/admin/update-placement', updatedPayload);
  },
};
export default placementService;
